import React, {useMemo, useState, useRef,  useContext , useEffect} from 'react';
import Context from "../context/context";

import Slot from './Slot';

const Grid = props => {
  const {pagedItems, opacity, filterView} = useContext(Context);



   return (
     <div className="grid" className={opacity ? 'grid active' : 'grid out' }>
     {pagedItems.map(item =>
        <Slot key={item.id} data={item} filterView={filterView} />
      )}
     </div>
   )





}
export default Grid;
